var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('slice-background-color-block');
import { breakpoints, theme } from '@shapeable/theme';
import { ImageEntityBackground } from './image-entity-background';
import { useEntity } from '../hooks/use-entity';
import { ImageEntity } from './image-entity';
import { first, trim } from 'lodash';
import { DarkMode } from '../context/theme-mode-context';
export var SliceBackgroundColorBlockDefaultProps = {
  aspectRatio: {
    base: 4 / 3,
    landscape: 21 / 9,
    tablet: 21 / 9,
    desktop: 2.5
  },
  imageBackgroundColor: '#00000000',
  maxLayoutWidth: '500px'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-blend-mode: hard-light, normal;\n  "], ["\n    background-blend-mode: hard-light, normal;\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n  "]))),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: row;\n    \n    ", "\n  "], ["\n    flex-direction: row;\n    \n    ", "\n  "])), function (_a) {
    var isReversed = _a.isReversed;
    return isReversed && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      flex-direction: row-reverse;\n    "], ["\n      flex-direction: row-reverse;\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: flex-start;\n    width: 100%;\n    background-blend-mode: overlay;\n  "], ["\n    padding: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: flex-start;\n    width: 100%;\n    background-blend-mode: overlay;\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 50%;\n  "], ["\n    width: 50%;\n  "]))),
  extra: theme.EXTRA_CSS // todo - deprecate this, it's a bit unclear, and css class patches are more obvious
});
var ImageStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    object-fit: contain;\n    width: 100%;\n  "], ["\n    object-fit: contain;\n    width: 100%;\n  "]))),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 50%;\n  "], ["\n    width: 50%;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(ImageEntityBackground)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Image: styled(ImageEntity)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var SliceBackgroundColorBlock = function (props) {
  var className = props.className,
    children = props.children,
    isReversed = props.isReversed,
    bodyStyles = props.bodyStyles,
    aspectRatio = props.aspectRatio,
    imageBackgroundColor = props.imageBackgroundColor,
    maxLayoutWidth = props.maxLayoutWidth;
  var entity = useEntity(props.entity);
  var intro = entity.intro,
    backgroundImages = entity.backgroundImages,
    images = entity.images;
  var backgroundColor = trim(props.backgroundColor || entity.backgroundColor && entity.backgroundColor.value || '#000000');
  var bgColor = "".concat(backgroundColor, "DD") || '#000000';
  var bgColor2 = "".concat(backgroundColor, "BB") || '#000000';
  var image = first(images);
  var firstHalfGradient = "linear-gradient(to ".concat(isReversed ? 'left' : 'right', ", ").concat(bgColor, " 0%, ").concat(bgColor, " 50%, ").concat(imageBackgroundColor, " 50%, ").concat(imageBackgroundColor, " 100%)");
  var secondHalfGradient = "linear-gradient(to ".concat(isReversed ? 'left' : 'right', ", ").concat(bgColor2, " 0%, ").concat(bgColor2, " 50%, ").concat(imageBackgroundColor, " 50%, ").concat(imageBackgroundColor, " 100%)");
  var firstGradient = "linear-gradient(to bottom, ".concat(bgColor, " 0%, ").concat(bgColor, " 100%)");
  var secondGradient = "linear-gradient(to bottom, ".concat(bgColor2, " 0%, ").concat(bgColor2, " 100%)");
  var halfGradient = "".concat(firstHalfGradient, ", ").concat(secondHalfGradient);
  var baseGradient = "".concat(firstGradient, ", ").concat(secondGradient);
  return React.createElement(My.Container, {
    aspectRatio: aspectRatio,
    items: backgroundImages,
    className: cls.name(className),
    baseTopImageStyles: baseGradient,
    landscapeTopImageStyles: baseGradient,
    tabletTopImageStyles: halfGradient,
    desktopTopImageStyles: halfGradient,
    desktopLargeTopImageStyles: halfGradient
  }, React.createElement(My.Layout, {
    maxLayoutWidth: maxLayoutWidth,
    isReversed: isReversed
  }, React.createElement(DarkMode, null, React.createElement(My.Body, {
    extraStyles: bodyStyles
  }, children), image && React.createElement(My.Image, {
    entity: image
  }))));
};
SliceBackgroundColorBlock.defaultProps = SliceBackgroundColorBlockDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;